import BodyCard from "../../../../components/fundamentals/body-card/body-card";
import TableViewHeader from "../../../../components/fundamentals/custom-table-header";
import OrderTable from "../orders-page/order-table/OrderTable";

const VIEWS = ["commandes Plateforme"];

/**
 * Page de suivi des commandes passées via la Plateforme Socoda : elle liste
 * uniquement les commandes contenant au moins un produit Plateforme, avec leur
 * état d'avancement vers l'ERP (en attente / erreur / transmise). Elle réutilise
 * le tableau des commandes, filtré côté API (paramètre platform=1).
 */
export default function PlatformOrdersPage() {
  return (
    <div className="flex flex-col grow h-full">
      <div className="w-full flex flex-col grow">
        <BodyCard
          forceDropdown={false}
          customHeader={<TableViewHeader views={VIEWS} />}
          className="h-fit"
        >
          <p className="inter-small-regular text-grey-50 mb-base">
            Toutes les commandes contenant au moins un produit de la Plateforme Socoda.
            La colonne « État » indique où en est l'envoi vers l'ERP.
          </p>
          <OrderTable platformOnly showStatus />
        </BodyCard>
      </div>
    </div>
  );
}
